<div [ngClass]="show ? 'blur' : 'main'" style="height: 100%; width: 100%; position: absolute">
<router-outlet></router-outlet>
</div>
<fm-progress-spinner [show]="show" [message]="message" ></fm-progress-spinner>
<cookie-law (isSeen)="onCookieAccepted($event)" *ngIf="angularLoaded && !cookieAccepted" learnMore="/legal/cookie-policy" ></cookie-law>
